/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React from "react"
import {  handleSystemConfig } from "../redux/systemConfigSlice"
import { useDispatch } from "react-redux"
import { dataService } from "../services/data.services"
import { useEffect } from "react"
import Profile from "./auth/Profile"
import { useNavigate, useLocation } from "react-router-dom"

export default function PatientSystemConfig(){
    const dispatch=useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    // Handle deep-link redirect for already-authenticated users.
    // When an authenticated user arrives at / with ?redirect=/some/path,
    // send them straight to the intended path instead of showing the profile.
    useEffect(()=>{
        // Check location.state first (from React Router internal navigation)
        const from = location.state?.from;
        if (from) {
            navigate(from.pathname + (from.search || ''), { replace: true });
        } else {
            // Check location.search for ?redirect= param (direct URL opening)
            const params = new URLSearchParams(location.search);
            const redirect = params.get("redirect");
            if (redirect) {
                navigate(decodeURIComponent(redirect), { replace: true });
            }
        }
    }, [])


    useEffect(()=>{
        const fetchData=async()=>{
            try{
                let response
                response = await dataService.GetAPI(`system-configuration/`);
                if(response.error===false){
                    dispatch(handleSystemConfig(response.data))
                }
            }catch(err){
            }
        }
        fetchData()
        return () => {
            // Cleanup logic, if needed
        };

    },[])

    return(
        <>
            <Profile/>
        </>
    )
}